import { graphql } from '~/graphql/generated/gql';

export const partnerMetaFragment = graphql(`
  fragment PartnerMetaFields on PartnerMeta {
    bgColorHex
  }
`);

export const adminPartnerMetaFragment = graphql(`
  fragment AdminPartnerMetaFields on AdminPartnerMeta {
    bgColorHex
  }
`);

export const adminPartnerFileFragment = graphql(`
  fragment AdminPartnerFileFields on AdminFile {
    id
    userId
    type
    path
    originalName
    publicUrl
    size
    mimeType
    title
  }
`);

export const adminPartnerFragment = graphql(`
  fragment AdminPartnerFields on AdminPartner {
    id
    name
    iconFileId
    iconFile {
      ...AdminPartnerFileFields
    }
    learningAssetCollections {
      id
      name
    }
    learningAssets {
      id
      name
      type
      publishedAt
    }
    meta {
      ...AdminPartnerMetaFields
    }
  }
`);

export const adminCompletableStatsFragment = graphql(`
  fragment AdminCompletableStatsFields on AdminCompletableStats {
    completions
    starts
    firstCompletedAt
    lastCompletedAt
  }
`);

export const adminCompletionSeriesFragment = graphql(`
  fragment AdminCompletionSeriesFields on AdminCompletableStats {
    completionsByDay {
      date
      completions
    }
    peakDay {
      date
      completions
    }
  }
`);

export const adminPartnerAssetInsightFragment = graphql(`
  fragment AdminPartnerAssetInsightFields on AdminPartnerLearningAsset {
    id
    name
    type
    publishedAt
    learningAssetCollections {
      id
      name
    }
    stats {
      ...AdminCompletableStatsFields
    }
  }
`);

export const adminPartnerInsightsFragment = graphql(`
  fragment AdminPartnerInsightsFields on AdminPartner {
    learningAssetCollections {
      id
      name
      publishedAt
      learningAssets {
        ...AdminPartnerAssetInsightFields
      }
      stats {
        ...AdminCompletableStatsFields
      }
    }
    learningAssets {
      ...AdminPartnerAssetInsightFields
    }
  }
`);

export const adminPartnerInsightSeriesFragment = graphql(`
  fragment AdminPartnerInsightSeriesFields on AdminPartner {
    learningAssetCollections {
      id
      learningAssets {
        id
        stats(days: $days) {
          ...AdminCompletionSeriesFields
        }
      }
      stats(days: $days) {
        ...AdminCompletionSeriesFields
      }
    }
    learningAssets {
      id
      stats(days: $days) {
        ...AdminCompletionSeriesFields
      }
    }
  }
`);

export const adminPartnerListFragment = graphql(`
  fragment AdminPartnerListFields on AdminPartner {
    id
    name
    createdAt
  }
`);

export const adminPartnerReferenceFragment = graphql(`
  fragment AdminPartnerReferenceFields on AdminPartner {
    id
    name
    iconFile {
      ...AdminPartnerFileFields
    }
    meta {
      ...AdminPartnerMetaFields
    }
  }
`);

export const partnerReferenceFragment = graphql(`
  fragment PartnerReferenceFields on Partner {
    id
    name
    iconFile {
      ...PublicFileFields
    }
    meta {
      ...PartnerMetaFields
    }
  }
`);

export const partnersList = graphql(`
  query partnersList($page: Int!, $first: Int!, $filters: PartnerFilters) {
    partnersList(page: $page, first: $first, filters: $filters) {
      data {
        ...AdminPartnerListFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const partnerDetail = graphql(`
  query partnerDetail($id: ID!) {
    partner(id: $id) {
      ...AdminPartnerFields
    }
  }
`);

export const partnerInsights = graphql(`
  query partnerInsights($id: ID!) {
    partner(id: $id) {
      ...AdminPartnerFields
      ...AdminPartnerInsightsFields
    }
  }
`);

export const partnerInsightSeries = graphql(`
  query partnerInsightSeries($id: ID!, $days: Int!) {
    partner(id: $id) {
      id
      ...AdminPartnerInsightSeriesFields
    }
  }
`);

export const upsertPartner = graphql(`
  mutation upsertPartner($input: UpsertPartnerInput!) {
    upsertPartner(input: $input) {
      partner {
        ...AdminPartnerFields
      }
    }
  }
`);

export const deletePartner = graphql(`
  mutation deletePartner($input: DeletePartnerInput!) {
    deletePartner(input: $input) {
      success
    }
  }
`);
